import { enumCMSTypes } from "constants/cms"
import { LanguageTypesEnum } from "constants/eums"

import { CMSService } from "services/cms/cms.service"
import { CMSActionResponse, CreateCMSPayload } from "services/cms/type"

export async function createCMSBonusBanner({
  tenantId,
  name,
  imageUrl,
  mobileImageUrl
}: {
  tenantId: string
  name: string
  imageUrl: string
  mobileImageUrl?: string
}): Promise<CMSActionResponse | null> {
  const resolvedMobileUrl = mobileImageUrl || imageUrl
  const cmsPayload: CreateCMSPayload = {
    active: true,
    tenant_id: tenantId,
    name,
    headline: "",
    subheadline: "",
    link: "",
    type: enumCMSTypes.BONUS_BANNER,
    banner_image: imageUrl,
    banner_image_mobile: resolvedMobileUrl,
    banners_languages: [
      {
        lang: LanguageTypesEnum.USA_English,
        desktop: imageUrl,
        mobile: resolvedMobileUrl,
        desktop_animation: "",
        is_desktop_animation: false,
        mobile_animation: "",
        is_mobile_animation: false,
        link: "",
        jackpots: false
      }
    ]
  }

  const cmsBanner = await CMSService.createCMS(cmsPayload)
  return cmsBanner ?? null
}
